import React, { useEffect, useState, useRef } from 'react';
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  TextField,
  IconButton,
  Autocomplete,
  Paper,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { API, graphqlOperation } from 'aws-amplify';
import { createPartyAddressEntity, getCodeTranslation, getPartyAddressEntity } from '../../../graphql';
import { LocationFetch } from '../../../library/LocationFetch';
import useSaveModalShortcut from '../Components/useSaveModalShortcut';
import { useSelector } from 'react-redux';
import { showSuccessSnackbar } from '../../../components/snackBar/snakbar';
import { FetchGstInDetails } from '../../../library/GstinFetch';
import { gstin } from '../../../utils/customerData';
import { useStateList } from '../Components/HandleInvoiceStateProvider';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
};
const countryArr = [{ option: 'India', value: 'IndiaState' }];
const EditDeliveryAddressModal = ({
  open,
  setOpen,
  partyID,
  setCountryArr,
  partyType,
  registrationType,
  addressType,
  setDeliveryAddressDetails,
  Type,
  stateArr,
  getStates,
  getDistricts,
  countryArr,
  districtArr,
  setDistrictArr,
  setStateArr,
  data,
  setData,
  invoiceEntry,
  tempdeliveryAddressDetails,
  setTempDeliveryAddressDetails,
  partyDeliveryAddressEntity,
  deliveryAddressDetails,
  cityArr,
  setCityArr,
}) => {
  const userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  function isEmptyDeliveryAddress(details) {
    const { deliveryAddress, states, district, country, pincode, stateCD, countryCD, districtCD, gstin, customerName } = details;

    const isEmptyVal = (val) => {
      if (val === null || val === undefined) return true;
      if (typeof val === 'string') return val.trim() === '' || val === '0';
      if (typeof val === 'object') {
        return Object.values(val).every((v) => v === '' || v === null || v === undefined || v === '0');
      }
      return false;
    };

    return (
      isEmptyVal(deliveryAddress) &&
      isEmptyVal(states?.value) &&
      isEmptyVal(district?.value) &&
      isEmptyVal(country?.value) &&
      isEmptyVal(pincode) &&
      isEmptyVal(stateCD) &&
      isEmptyVal(countryCD) &&
      isEmptyVal(districtCD) &&
      isEmptyVal(gstin) &&
      isEmptyVal(customerName)
    );
  }

  const isConsigneeEmpy = data?.consigneeName === '' || data?.consigneeGST === '';
  const isEmptyInvDeliveryAddress = isEmptyDeliveryAddress(deliveryAddressDetails);
  const isEmptyPartyDelivery =
    !partyDeliveryAddressEntity ||
    (Object.keys(partyDeliveryAddressEntity).length === 0 && partyDeliveryAddressEntity.constructor === Object);
  const isAdrressEmpty = !isEmptyInvDeliveryAddress || !isEmptyPartyDelivery || !isConsigneeEmpy;
  const objectType = Type === 'Purchase' ? 'PurchaseBilling' : 'Sales' ? 'SalesBilling' : 'CreditNote' ? 'CreditBilling' : 'DebitBilling';
  const delObjectType =
    Type === 'Purchase' ? 'PurchaseDelivery' : 'Sales' ? 'SalesDelivery' : 'CreditNote' ? 'CreditDelivery' : 'DebitDelivery';
  const invoiceID = Type === 'Purchase' ? invoiceEntry?.purchaseid : 'Sales' ? invoiceEntry?.invoiceid : invoiceEntry?.crdrnoteid;
  const delAddressType = invoiceEntry.length === 0 ? 'PartyDelivery' : delObjectType;
  const TypeOfAddress = invoiceEntry.length === 0 ? 'PartyBilling' : objectType;
  const addressID = invoiceEntry.length === 0 ? data.partyName?.value : invoiceID;
  const [editFlag, setEditFlag] = useState(false);
  const [openState, setOpenState] = useState(false);
  const [checkPermanent, setCheckPermanent] = useState(false);
  const [isChanges, setIsChanged] = useState(false);
  const [fetchGST, setFetchGST] = useState(false);
    const{eImp ,eWayImp}=useStateList();

  const [state, setState] = useState({
    deliveryAddress: isAdrressEmpty ? deliveryAddressDetails?.deliveryAddress : '',
    states: isAdrressEmpty ? deliveryAddressDetails?.stateCD : { label: '', value: '', code: '' },
    district: isAdrressEmpty ? deliveryAddressDetails?.districtCD : { label: '', value: '' },
    country: isAdrressEmpty ? deliveryAddressDetails?.countryCD : { label: 'India', value: 'IndiaState' },
    city: isAdrressEmpty ? deliveryAddressDetails?.city : { label: '', value: '' },
    pincode: isAdrressEmpty ? deliveryAddressDetails?.pincode : '',
    customerName: data?.sameAsBilling === true ? data?.partyName?.label : data?.consigneeName,
    gstin: data?.sameAsBilling === true ? data?.gstin : data.consigneeGST,

    errorStatus: {
      deliveryAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      customerName: false,
      gstin: false,
      city: false,
    },
    errorFields: {
      deliveryAddress: '',
      states: "",
      district: "",
      country:"" ,
      pincode: '',
      customerName: '',
      gstin: '',
      city: '',
    },
  });
  const handleClear = () => {
    setState((prev) => ({
      ...prev,
      deliveryAddress: '',
      states: { label: '', value: 0, code: 0 },
      district: { label: '', value: '' },
      country: { label: 'India', value: 'IndiaState' },
      city: { label: '', value: '' },
      pincode: '',
      customerName: '',
      gstin: '',
      errorStatus: {
        ...prev.errorStatus,
        deliveryAddress: false,
        states: false,
        district: false,
        country: false,
        pincode: false,
        customerName: false,
        city: false,
        gstin: false,
      },
      errorFields: {
        ...prev.errorFields,
        deliveryAddress: '',
        states: '',
        district: '',
        country: '',
        pincode: '',
        customerName: '',
        city: '',
        gstin: '',
      },
    }));
    setCityArr([]);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };
  // function formValidation(data) {
  //   let isvalid = true;
  //   let obj = { ...state };

  //   Object.keys(data).map((key) => {
  //     // if (key === "deliveryAddress") {
  //     //   if (data[key]?.trim().length <= 0) {
  //     //     isvalid = false;
  //     //     obj.errorFields.deliveryAddress = "Delivery Address is required";
  //     //     obj.errorStatus.deliveryAddress = true;
  //     //   } else {
  //     //     // isvalid=true;
  //     //     obj.errorFields.deliveryAddress = "";
  //     //     obj.errorStatus.deliveryAddress = false;
  //     //   }
  //     // }
  //     if (key === 'pincode') {
  //       // if (data[key]?.trim().length <= 0) {
  //       //   isvalid = false;
  //       //   obj.errorFields.pincode = "Postal / Zip Code is required";
  //       //   obj.errorStatus.pincode = true;
  //       // } else
  //       if (data[key]?.trim().length > 0) {
  //         if (!new RegExp(/^\d{6}$/).test(data[key])) {
  //           isvalid = false;
  //           obj.errorFields.pincode = 'Invalid Postal / Zip Code ';
  //           obj.errorStatus.pincode = true;
  //         } else {
  //           obj.errorFields.pincode = '';
  //           obj.errorStatus.pincode = false;
  //         }
  //       }
  //     }

  //     // if (key === "country") {
  //     //   if (data[key]?.value?.trim().length <= 0) {
  //     //     isvalid = false;
  //     //     obj.errorFields.country = "Country is required";
  //     //     obj.errorStatus.country = true;
  //     //   } else {
  //     //     // isvalid=true;
  //     //     obj.errorFields.country = "";
  //     //     obj.errorStatus.country = false;
  //     //   }
  //     // }

  //     // if (key === "states") {
  //     //   if (data[key].value?.trim().length <= 0) {
  //     //     isvalid = false;
  //     //     obj.errorFields.states = "State/Province is required";
  //     //     obj.errorStatus.states = true;
  //     //   } else {
  //     //     // isvalid=true;
  //     //     obj.errorFields.states = "";
  //     //     obj.errorStatus.states = false;
  //     //   }
  //     // }
  //     // if (key === "district") {
  //     //   if (data[key].value?.trim().length <= 0) {
  //     //     isvalid = false;
  //     //     obj.errorFields.district = "District is required";
  //     //     obj.errorStatus.district = true;
  //     //   } else {
  //     //     // isvalid=true;
  //     //     obj.errorFields.district = "";
  //     //     obj.errorStatus.district = false;
  //     //   }
  //     // }
  //   });
  //   setState(obj);
  //   return isvalid;
  // }

  // async function getAddressDetails() {
  //   try {
  //     const resPartyAddressEntityDetails = await API.graphql(
  //       graphqlOperation(getPartyAddressEntity, {
  //         objectid: addressID,
  //         objecttype: data?.sameAsBilling === true ? TypeOfAddress : 'PartyDelivery',
  //       })
  //     );
  //     console.log(
  //       'resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]',
  //       resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]
  //     );

  //     if (resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]) {
  //       let nameOfCountry = { label: '', value: '' };
  //       countryArr.map((ele) => {
  //         if (ele.value === resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].countrycode) {
  //           nameOfCountry = { label: ele.label, value: ele.value };
  //         }
  //       });
  //       let nameOfState = { label: '', value: '' };
  //       stateArr.map((ele) => {
  //         if (ele.code == resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode)
  //           nameOfState = {
  //             label: ele.label,
  //             value: ele.value,
  //             code: ele?.code,
  //           };
  //       });
  //       const selectedCity =
  //         tempdeliveryAddressDetails?.city?.label?.trim() || resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0]?.city || '';

  //       const city = {
  //         label: selectedCity,
  //         value: selectedCity,
  //       };
  //       setState((prev) => ({
  //         ...prev,
  //         customerName: tempdeliveryAddressDetails?.customerName
  //           ? tempdeliveryAddressDetails.customerName
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.consigneename,
  //         gstin: tempdeliveryAddressDetails?.gstin
  //           ? tempdeliveryAddressDetails?.gstin
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.consigneegstin,
  //         deliveryAddress:
  //           tempdeliveryAddressDetails.deliveryAddress !== ''
  //             ? tempdeliveryAddressDetails.deliveryAddress
  //             : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].line1.replace('**', '\n'),
  //         country: tempdeliveryAddressDetails.country.value !== '' ? tempdeliveryAddressDetails.country : nameOfCountry,
  //         pincode:
  //           tempdeliveryAddressDetails.pincode !== ''
  //             ? tempdeliveryAddressDetails.pincode
  //             : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].pincode,
  //         city: city,
  //       }));
  //       getStatesModal(
  //         tempdeliveryAddressDetails.country.value !== ''
  //           ? tempdeliveryAddressDetails.country.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].countrycode,
  //         tempdeliveryAddressDetails.states.value !== ''
  //           ? tempdeliveryAddressDetails.states.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode
  //       );
  //       getDistrictsModal(
  //         // resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode,
  //         tempdeliveryAddressDetails.states.value !== '' ? tempdeliveryAddressDetails.states.value : nameOfState?.value,
  //         tempdeliveryAddressDetails.district.value !== ''
  //           ? tempdeliveryAddressDetails.district.value !== ''
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].district
  //       );
  //       getCityArr(
  //         tempdeliveryAddressDetails.pincode !== ''
  //           ? tempdeliveryAddressDetails.pincode
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].pincode
  //       );
  //     }

  //     // else {
  //     //   let nameOfCountry = { label: '', value: '' };
  //     //   console.log("countryArr",tempdeliveryAddressDetails.country.value,countryArr);

  //     //   countryArr.map((ele) => {
  //     //     if (ele.value === tempdeliveryAddressDetails.country.value) {
  //     //       nameOfCountry = { label: ele.label, value: ele.value };
  //     //     }
  //     //   });
  //     //   let nameOfState = { label: '', value: '' };
  //     //   stateArr.map((ele) => {
  //     //     if (ele.code == tempdeliveryAddressDetails.states.code)
  //     //       nameOfState = {
  //     //         label: ele.label,
  //     //         value: ele.value,
  //     //         code: ele?.code,
  //     //       };
  //     //   });
  //     //   setState((prev) => ({
  //     //     ...prev,
  //     //     deliveryAddress: tempdeliveryAddressDetails.deliveryAddress ?? '',

  //     //     country: tempdeliveryAddressDetails.country.value !== '' ? tempdeliveryAddressDetails.country : nameOfCountry,
  //     //     pincode: tempdeliveryAddressDetails.pincode ?? '',
  //     //   }));
  //     //   getStatesModal(tempdeliveryAddressDetails.country.value, tempdeliveryAddressDetails.states.value);
  //     //   getDistrictsModal(
  //     //     // resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode,
  //     //     tempdeliveryAddressDetails.states.value !== '' ? tempdeliveryAddressDetails.states.value : nameOfState?.value,
  //     //     tempdeliveryAddressDetails.district.value
  //     //   );
  //     // }
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // }
   function formValidation(data) {
  let isValid = true;
  const obj = { ...state };

  // Reset previous errors
  Object.keys(obj.errorStatus).forEach((key) => {
    obj.errorStatus[key] = false;
    obj.errorFields[key] = '';
  });

  
  if(eWayImp){
  if (!data.deliveryAddress || data.deliveryAddress.trim() === '') {
    isValid = false;
    obj.errorStatus.deliveryAddress = true;
    obj.errorFields.deliveryAddress = 'Delivery address is required';
  }

}
 if(eWayImp){
  if (!data.country?.value) {
    isValid = false;
    obj.errorStatus.country = true;
    obj.errorFields.country = 'Country is required';
  }
}
if(data?.country?.value==="IndiaState" || data?.country?.value===""){
  if(eWayImp){
  if (!data.states?.value) {
    isValid = false;
    obj.errorStatus.states = true;
    obj.errorFields.states = 'State is required';
  }
}

  if(eWayImp){
  if (!data.district?.value) {
    isValid = false;
    obj.errorStatus.district = true;
    obj.errorFields.district = 'District is required';
  }
  }
 

   if(eWayImp){
  if (!data.city?.value || data.city.label.trim() === '') {
    isValid = false;
    obj.errorStatus.city = true;
    obj.errorFields.city = 'City is required';
  }
   }
  if(eWayImp){
  if (!data.pincode || data.pincode.trim() === '') {
    isValid = false;
    obj.errorStatus.pincode = true;
    obj.errorFields.pincode = 'Pincode is required';
  } else if (!/^\d{6}$/.test(data.pincode.trim())) {
    isValid = false;
    obj.errorStatus.pincode = true;
    obj.errorFields.pincode = 'Invalid Postal / Zip Code';
  }
}
}


  setState(obj);
  return isValid;
}
  async function getAddressDetails() {
    try {
      const resPartyAddressEntityDetails = await API.graphql(
        graphqlOperation(getPartyAddressEntity, {
          objectid: addressID,
          objecttype: data?.sameAsBilling === true ? TypeOfAddress : 'PartyDelivery',
        })
      );

      const partyAddr = resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0];
      if (partyAddr) {
        let nameOfCountry = { label: '', value: '' };
        let nameOfDistrict = { label: '', value: '' };
        countryArr.map((ele) => {
          if (ele.value === partyAddr.countrycode) {
            nameOfCountry = { label: ele.label, value: ele.value };
          }
        });

        let nameOfState = { label: '', value: '', code: '' };

        if (partyAddr.countrycode === 'IndiaState') {
          stateArr.map((ele) => {
            if (ele.code == partyAddr.statecode) {
              nameOfState = { label: ele.label, value: ele.value, code: ele?.code };
            }
          });
          getStatesModal(
            tempdeliveryAddressDetails?.country?.value !== undefined && tempdeliveryAddressDetails?.country?.value !== null
              ? tempdeliveryAddressDetails.country.value
              : partyAddr?.countrycode,
            tempdeliveryAddressDetails?.states?.value !== undefined && tempdeliveryAddressDetails?.states?.value !== null
              ? tempdeliveryAddressDetails.states.value
              : partyAddr?.statecode
          );

          getDistrictsModal(
            tempdeliveryAddressDetails?.states?.value !== undefined && tempdeliveryAddressDetails?.states?.value !== null
              ? tempdeliveryAddressDetails.states.value
              : nameOfState?.value,
            tempdeliveryAddressDetails?.district?.value !== undefined && tempdeliveryAddressDetails?.district?.value !== null
              ? tempdeliveryAddressDetails.district.value
              : partyAddr?.district
          );
        } else {
          nameOfState = {
            label:
              tempdeliveryAddressDetails?.states?.label !== undefined && tempdeliveryAddressDetails?.states?.label !== null
                ? tempdeliveryAddressDetails?.states?.label
                : partyAddr.foreignstate,
            value: 0,
            code: 0,
          };
          nameOfDistrict = {
            label:
              tempdeliveryAddressDetails?.district?.label !== undefined && tempdeliveryAddressDetails?.district?.label !== null
                ? tempdeliveryAddressDetails.district.label
                : partyAddr?.foreigndistrict,
            value:
              tempdeliveryAddressDetails?.district?.label !== undefined && tempdeliveryAddressDetails?.district?.label !== null
                ? tempdeliveryAddressDetails.district.label
                : partyAddr?.foreigndistrict,
          };
          setState((prev) => ({
            ...prev,
            states: nameOfState,
            district: nameOfDistrict,
          }));
        }
        const selectedCity =
          tempdeliveryAddressDetails?.city?.label !== undefined && tempdeliveryAddressDetails?.city?.label !== null
            ? tempdeliveryAddressDetails.city.label
            : partyAddr?.city ?? '';

        const city = { label: selectedCity, value: selectedCity };

        setState((prev) => ({
          ...prev,
          customerName:
            tempdeliveryAddressDetails?.customerName !== undefined && tempdeliveryAddressDetails?.customerName !== null
              ? tempdeliveryAddressDetails.customerName
              : partyAddr?.consigneename,
          gstin:
            tempdeliveryAddressDetails?.gstin !== undefined && tempdeliveryAddressDetails?.gstin !== null
              ? tempdeliveryAddressDetails.gstin
              : partyAddr?.consigneegstin,
          deliveryAddress:
            tempdeliveryAddressDetails?.deliveryAddress !== undefined && tempdeliveryAddressDetails?.deliveryAddress !== null
              ? tempdeliveryAddressDetails.deliveryAddress
              : partyAddr?.line1,
          country:
            tempdeliveryAddressDetails?.country?.value !== undefined && tempdeliveryAddressDetails?.country?.value !== null
              ? tempdeliveryAddressDetails.country
              : nameOfCountry,
          pincode:
            tempdeliveryAddressDetails?.pincode !== undefined && tempdeliveryAddressDetails?.pincode !== null
              ? tempdeliveryAddressDetails.pincode
              : partyAddr?.pincode,
          city,
        }));

        getCityArr(
          tempdeliveryAddressDetails?.pincode !== undefined && tempdeliveryAddressDetails?.pincode !== null
            ? tempdeliveryAddressDetails.pincode
            : partyAddr?.pincode
        );
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  // async function getAddressDetailsByInvId() {
  //   try {
  //     const resPartyAddressEntityDetails = await API.graphql(
  //       graphqlOperation(getPartyAddressEntity, {
  //         objectid: Type === 'Sales' ? invoiceEntry.invoiceid : Type === 'Purchase' ? invoiceEntry.purchaseid : invoiceEntry.crdrnoteid,
  //         objecttype: addressType,
  //       })
  //     );
  //     console.log(resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]);

  //     if (resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]) {
  //       let nameOfCountry = { label: '', value: '' };

  //       countryArr.map((ele) => {
  //         if (ele.value === resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].countrycode) {
  //           nameOfCountry = { label: ele.label, value: ele.value };
  //         }
  //       });

  //       let nameOfState = { label: '', value: '', code: '' };
  //       stateArr.map((ele) => {
  //         if (ele.code == resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode)
  //           nameOfState = {
  //             label: ele.label,
  //             value: ele.value,
  //             code: ele?.code,
  //           };
  //       });
  //       const selectedCity =
  //         tempdeliveryAddressDetails?.city?.label?.trim() || resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0]?.city || '';

  //       const city = {
  //         label: selectedCity,
  //         value: selectedCity,
  //       };
  //       setState((prev) => ({
  //         ...prev,
  //         customerName: resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.consigneename,
  //         gstin: resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0]?.consigneegstin,
  //         deliveryAddress:
  //           tempdeliveryAddressDetails.deliveryAddress !== ''
  //             ? tempdeliveryAddressDetails.deliveryAddress
  //             : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].line1.replace('**', '\n'),
  //         country: tempdeliveryAddressDetails.country.value !== '' ? tempdeliveryAddressDetails.country : nameOfCountry,
  //         pincode:
  //           tempdeliveryAddressDetails.pincode !== ''
  //             ? tempdeliveryAddressDetails.pincode
  //             : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].pincode,
  //         city: city,
  //       }));
  //       getStatesModal(
  //         tempdeliveryAddressDetails.country.value !== ''
  //           ? tempdeliveryAddressDetails.country.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].countrycode,
  //         tempdeliveryAddressDetails.states.value !== ''
  //           ? tempdeliveryAddressDetails.states.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode
  //       );

  //       getDistrictsModal(
  //         // resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode,
  //         tempdeliveryAddressDetails.states.value !== '' ? tempdeliveryAddressDetails.states.value : nameOfState?.value,
  //         tempdeliveryAddressDetails.district.value !== ''
  //           ? tempdeliveryAddressDetails.district.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].district
  //       );
  //       getCityArr(
  //         tempdeliveryAddressDetails.pincode !== ''
  //           ? tempdeliveryAddressDetails.pincode
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].pincode
  //       );
  //     }
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // }
  async function getAddressDetailsByInvId() {
    try {
      const resPartyAddressEntityDetails = await API.graphql(
        graphqlOperation(getPartyAddressEntity, {
          objectid: Type === 'Sales' ? invoiceEntry.invoiceid : Type === 'Purchase' ? invoiceEntry.purchaseid : invoiceEntry.crdrnoteid,
          objecttype: addressType,
        })
      );

      const partyAddr = resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0];

      if (partyAddr) {
        let nameOfCountry = { label: '', value: '' };
        let nameOfDistrict = { label: '', value: '' };
        countryArr.map((ele) => {
          if (ele.value === partyAddr.countrycode) {
            nameOfCountry = { label: ele.label, value: ele.value };
          }
        });

        let nameOfState = { label: '', value: '', code: '' };
        if (partyAddr.countrycode === 'IndiaState') {
          stateArr.map((ele) => {
            if (ele.code == partyAddr.statecode) {
              nameOfState = { label: ele.label, value: ele.value, code: ele?.code };
            }
          });
          getStatesModal(
            tempdeliveryAddressDetails?.country?.value !== undefined && tempdeliveryAddressDetails?.country?.value !== null
              ? tempdeliveryAddressDetails.country.value
              : partyAddr?.countrycode,
            tempdeliveryAddressDetails?.states?.value !== undefined && tempdeliveryAddressDetails?.states?.value !== null
              ? tempdeliveryAddressDetails.states.value
              : partyAddr?.statecode
          );

          getDistrictsModal(
            tempdeliveryAddressDetails?.states?.value !== undefined && tempdeliveryAddressDetails?.states?.value !== null
              ? tempdeliveryAddressDetails.states.value
              : nameOfState?.value,
            tempdeliveryAddressDetails?.district?.value !== undefined && tempdeliveryAddressDetails?.district?.value !== null
              ? tempdeliveryAddressDetails.district.value
              : partyAddr?.district
          );
        } else {
          nameOfState = {
            label:
              tempdeliveryAddressDetails?.states?.label !== undefined && tempdeliveryAddressDetails?.states?.label !== null
                ? tempdeliveryAddressDetails?.states?.label
                : partyAddr.foreignstate,
            value: 0,
            code: 0,
          };
          nameOfDistrict = {
            label:
              tempdeliveryAddressDetails?.district?.label !== undefined && tempdeliveryAddressDetails?.district?.label !== null
                ? tempdeliveryAddressDetails.district.label
                : partyAddr?.foreigndistrict,
            value:
              tempdeliveryAddressDetails?.district?.label !== undefined && tempdeliveryAddressDetails?.district?.label !== null
                ? tempdeliveryAddressDetails.district.label
                : partyAddr?.foreigndistrict,
          };
          setState((prev) => ({
            ...prev,
            states: nameOfState,
            district: nameOfDistrict,
          }));
        }

        const selectedCity =
          tempdeliveryAddressDetails?.city?.label !== undefined && tempdeliveryAddressDetails?.city?.label !== null
            ? tempdeliveryAddressDetails.city.label
            : partyAddr?.city ?? '';

        const city = { label: selectedCity, value: selectedCity };

        setState((prev) => ({
          ...prev,
          customerName:
            tempdeliveryAddressDetails?.customerName !== undefined && tempdeliveryAddressDetails?.customerName !== null
              ? tempdeliveryAddressDetails.customerName
              : partyAddr?.consigneename,
          gstin:
            tempdeliveryAddressDetails?.gstin !== undefined && tempdeliveryAddressDetails?.gstin !== null
              ? tempdeliveryAddressDetails.gstin
              : partyAddr?.consigneegstin,
          deliveryAddress:
            tempdeliveryAddressDetails?.deliveryAddress !== undefined && tempdeliveryAddressDetails?.deliveryAddress !== null
              ? tempdeliveryAddressDetails.deliveryAddress
              : partyAddr?.line1,
          country:
            tempdeliveryAddressDetails?.country?.value !== undefined && tempdeliveryAddressDetails?.country?.value !== null
              ? tempdeliveryAddressDetails.country
              : nameOfCountry,
          pincode:
            tempdeliveryAddressDetails?.pincode !== undefined && tempdeliveryAddressDetails?.pincode !== null
              ? tempdeliveryAddressDetails.pincode
              : partyAddr?.pincode,
          city,
        }));

        getCityArr(
          tempdeliveryAddressDetails?.pincode !== undefined && tempdeliveryAddressDetails?.pincode !== null
            ? tempdeliveryAddressDetails.pincode
            : partyAddr?.pincode
        );
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  async function getStatesModal(code, state) {
    try {
      let nameOfstate = { label: '', value: '', code: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: code }));
      if (cities?.data?.getCodeTranslation != null) {
        let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
          return {
            label: element.codetext,
            value: `${element.codetext}District`,
            code: element?.statecode,
          };
        });
        statesArray.map((ele) => {
          if (ele.code == state) {
            nameOfstate = {
              label: ele.label,
              value: ele.value,
              code: ele?.code,
            };
          }
        });
        setState((prev) => ({
          ...prev,

          states: tempdeliveryAddressDetails.states.value !== '' ? tempdeliveryAddressDetails.states : nameOfstate,
        }));
        setStateArr(statesArray);
      }
    } catch (error) {}
  }
  async function getDistrictsModal(state, district) {
    try {
      let nameOfDistrict = { label: '', value: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: state }));

      let disArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          label: element.codetext,
          value: `${element.codetext}District`,
        };
      });
      disArray.map((ele) => {
        if (ele.value?.trim()?.toLowerCase() === district?.trim()?.toLowerCase()) {
          nameOfDistrict = { label: ele.label, value: ele.value };
        }
      });

      setState((prev) => ({
        ...prev,
        district: tempdeliveryAddressDetails.district.value !== '' ? tempdeliveryAddressDetails.district : nameOfDistrict,
      }));
      setDistrictArr(disArray);
    } catch (error) {}
  }
  async function getCountries() {
    let code = 'Country';
    const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: code }));

    if (cities?.data?.getCodeTranslation != null) {
      let countriesArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          label: element.codetext,
          value: `${element.codetext}State`,
        };
      });
      setCountryArr(countriesArray);
    }
  }
  useEffect(() => {
    getCountries();
  }, []);
  useEffect(() => {
    if (editFlag == false) {
      if (invoiceEntry.length == 0) {
        getAddressDetails();
      } else {
        getAddressDetailsByInvId();
      }
    }
  }, [open, editFlag]);
  async function saveChanges() {
    const { deliveryAddress, country, states, district, pincode, city } = state;
    const formData = {
      deliveryAddress,
      country,
      states,
      district,
      pincode,
      city,
    };
    let nameOfstate = { label: '', value: 0, code: 0 };
    let nameOfDistrict = { label: '', value: '' };
    let nameOfCountry = { label: '', value: '' };

    countryArr.map((ele) => {
      if (ele.value === country.value) {
        nameOfCountry = { label: ele.label, value: ele.value };
      }
    });

    if (country?.value === 'IndiaState') {
      districtArr.map((ele) => {
        if (ele?.value?.trim()?.toLowerCase() === district?.value?.trim()?.toLowerCase()) {
          nameOfDistrict = { label: ele.label, value: ele.value };
        }
      });
      stateArr.map((ele) => {
        if (ele.code === states.code) {
          nameOfstate = { label: ele?.label, value: ele?.value, code: ele?.code };
        }
      });
    } else {
      nameOfstate = { label: states?.label, value: 0, code: 0 };
      nameOfDistrict = { label: district?.label, value: district.value };
    }

    if (formValidation(formData)) {
      setState((prev) => ({
        ...prev,
        deliveryAddress: deliveryAddress ?? '',
        country: nameOfCountry,
        district: nameOfDistrict,
        states: nameOfstate,
        pincode: pincode,
        city: city,
        cityCD: city,
        stateCD: nameOfstate,
        districtCD: nameOfDistrict,
      }));
      setTempDeliveryAddressDetails((prev) => ({
        ...prev,
        customerName: state?.customerName,
        gstin: state?.gstin,
        deliveryAddress: deliveryAddress ?? '',
        country: nameOfCountry,
        district: nameOfDistrict,
        states: nameOfstate,
        pincode: pincode,
        stateCD: nameOfstate,
        districtCD: nameOfDistrict,
        city: city,
        cityCD: city,
      }));
      setDeliveryAddressDetails((prev) => ({
        ...prev,
        deliveryAddress: deliveryAddress ?? '',
        country: nameOfCountry.value ?? '',
        district: nameOfDistrict.value ?? '',
        states: nameOfstate.code ?? 0,
        pincode: pincode ?? '',
        stateCD: nameOfstate,
        districtCD: nameOfDistrict,
        countryCD: nameOfCountry,
        city: city,
        cityCD: city,
        customerName: state?.customerName,
        gstin: state?.gstin,
      }));
      setData((prev) => ({
        ...prev,
        consigneeName: state?.customerName,
        consigneeGST: state?.gstin,
      }));
      setEditFlag(true);
      if (checkPermanent === true) {
        saveBillingAddressPermanently();
      }
      setData((prev) => ({
        ...prev,
        sameAsBilling: false,
      }));
      setOpen(false);
    }
  }

  useEffect(() => {
    if (isAdrressEmpty && !fetchGST) {
      setState((prev) => ({
        ...prev,
        deliveryAddress: isAdrressEmpty ? deliveryAddressDetails?.deliveryAddress : '',
        states: isAdrressEmpty ? deliveryAddressDetails?.stateCD : { label: '', value: '', code: '' },
        district: isAdrressEmpty ? deliveryAddressDetails?.districtCD : { label: '', value: '' },
        country: isAdrressEmpty ? deliveryAddressDetails?.countryCD : { label: '', value: '' },
        city: isAdrressEmpty ? deliveryAddressDetails?.city : { label: '', value: '' },
        pincode: isAdrressEmpty ? deliveryAddressDetails?.pincode : '',
        customerName: data?.sameAsBilling === true ? data?.partyName?.label : state?.customerName,
        gstin: data?.sameAsBilling === true ? data?.gstin : state?.gstin,
      }));
      getStatesModal(tempdeliveryAddressDetails.countryCD.value, tempdeliveryAddressDetails.stateCD.value);

      getDistrictsModal(
        // resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode,
        tempdeliveryAddressDetails.stateCD.value,
        tempdeliveryAddressDetails.districtCD.value
      );
      getCityArr(deliveryAddressDetails?.pincode);
    }
  }, [open, isAdrressEmpty, data?.sameAsBilling, deliveryAddressDetails]);
  async function saveBillingAddressPermanently() {
    try {
      // Ensure billAdd is always an array
      let billAdd = state?.deliveryAddress ? state?.deliveryAddress : '';

      const billaddressDetails = {
        consigneename: String(state.customerName) ?? '',
        consigneegstin: String(state.gstin) ?? '',
        city: state?.city?.value ?? '',
        countrycode: state?.country?.value ?? '',
        line1: billAdd.length > 0 ? billAdd : '', // safe join
        line2: '',
        line3: '',
        objectid: data?.partyName?.value,
        objecttype: 'PartyDelivery',
        pincode: state?.pincode ?? '',
        statecode: state?.states?.code ?? 0,
        district: state?.district?.value ?? '',
        expiredtimestamp: 0,
        financialyearid: userPreferece?.financialYear?.financialyearid,
        foreignstate: state?.states?.label ?? '',
        foreigndistrict: state?.district?.label ?? '',
      };

      const resPartyBillingAddressEntity = await API.graphql(
        graphqlOperation(createPartyAddressEntity, {
          createPartyAddressEntityInput: [billaddressDetails],
        })
      );

      if (resPartyBillingAddressEntity?.data?.createPartyAddressEntity) {
        setIsChanged(false);
        setCheckPermanent(false);
        const role = partyType === 'CUSTOMER' ? 'customer' : 'supplier';
        showSuccessSnackbar(`The ship to address has been saved permanently for the ${role}.`);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  async function getGSTDetails(gstIn) {
    try {
      let fetchData = await FetchGstInDetails(gstIn);
      if (fetchData) {
        const fullAddress = [fetchData?.data?.AddressLine1, fetchData?.data?.AddressTest, fetchData?.data?.AddressLine2]
          .filter(Boolean)
          .join(', ');

        setData((prev) => ({
          ...prev,
          consigneeGST: fetchData?.data?.GstIn,
          consigneeName: fetchData?.data?.LegalName,
        }));
        LocationFetch(fetchData?.data?.Address?.PinCode)
          .then((res) => {
            getStates('IndiaState');
            GSTStatesModal('IndiaState', `${res?.State}District`);
            GSTDistrictsModal(`${res?.State}District`, `${res?.District}District`);
            let cityArr = [];
            let citObj = { label: '', value: '' };
            if (res?.City) {
              res.City.map((ele) => {
                citObj = { label: ele, value: ele };
                cityArr.push(citObj);
              });
              setCityArr(cityArr);
            }
            setState((prev) => ({
              ...prev,
              gstin: fetchData?.data?.GstIn,
              customerName: fetchData?.data?.LegalName,
              deliveryAddress: fullAddress ?? '',
              country: { label: 'India', value: 'IndiaState' },
              pincode: fetchData?.data?.Address?.PinCode,
              city: { label: cityArr?.[0]?.label, value: cityArr?.[0]?.value },
            }));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  async function GSTStatesModal(code, state) {
    try {
      let nameOfstate = { label: '', value: '', code: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: code }));
      if (cities?.data?.getCodeTranslation != null) {
        let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
          return {
            label: element.codetext,
            value: `${element.codetext}District`,
            code: element?.statecode,
          };
        });
        statesArray.map((ele) => {
          if (ele.value?.trim()?.toLowerCase() === state?.trim()?.toLowerCase()) {
            nameOfstate = {
              label: ele.label,
              value: ele.value,
              code: ele?.code,
            };
          }
        });
        setState((prev) => ({
          ...prev,
          states: nameOfstate,
        }));
        setStateArr(statesArray);
      }
    } catch (error) {}
  }
  async function GSTDistrictsModal(state, district) {
    try {
      let nameOfDistrict = { label: '', value: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: state }));

      let disArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          label: element.codetext,
          value: `${element.codetext}District`,
        };
      });
      disArray.map((ele) => {
        if (ele.value?.trim()?.toLowerCase() === district?.trim()?.toLowerCase()) {
          nameOfDistrict = { label: ele.label, value: ele.value };
        }
      });
      setState((prev) => ({
        ...prev,
        district: nameOfDistrict,
      }));
      setDistrictArr(disArray);
    } catch (error) {}
  }
  async function getCityArr(value) {
    try {
      const res = await LocationFetch(value); // waits for the fetch

      let cityArr = [];
      let citObj = { label: '', value: '' };
      if (res?.City) {
        res.City.map((ele) => {
          citObj = { label: ele, value: ele };
          cityArr.push(citObj);
        });

        setCityArr(cityArr);
      }
    } catch (error) {
      console.log('error', error);
      return null;
    }
  }
const handleDeliveryAddressChange = (e) => {
  const { name, value } = e.target;

  // Track change status
  setIsChanged(value !== state?.deliveryAddress);

  let hasError = false;
  let errorMessage = '';

  // Inline validation
  if (value.trim() === '') {
    hasError = true;
    errorMessage = 'Delivery Address is required';
  } else if (value.trim().length < 5) {
    hasError = true;
    errorMessage = 'Delivery Address must be at least 5 characters long';
  }

  // Update state
  setState((prev) => ({
    ...prev,
    deliveryAddress: value,
    errorStatus: { ...prev.errorStatus, deliveryAddress: hasError },
    errorFields: { ...prev.errorFields, deliveryAddress: errorMessage },
  }));
};
const handlePincodeChange = async (e) => {
  const { name, value } = e.target;
  let nameOfState = { label: '', value: '', code: '' };

  // Track changes
  setIsChanged(value !== state?.pincode);

  // Case 1 — Empty input → clear all dependent fields
  if (value === '') {
    setState((prev) => ({
      ...prev,
      pincode: '',
      states: { label: '', value: '', code: '' },
      district: { label: '', value: '' },
      city: { label: '', value: '' },
      errorStatus: { ...prev.errorStatus, pincode: false },
      errorFields: { ...prev.errorFields, pincode: '' },
    }));
    return;
  }

  // Case 2 — Invalid pincode (must be 6 digits)
  if (!/^\d{6}$/.test(value)) {
    setState((prev) => ({
      ...prev,
      pincode: value,
      errorStatus: { ...prev.errorStatus, pincode: true },
      errorFields: { ...prev.errorFields, pincode: 'Invalid Postal / Zip Code' },
    }));
    return;
  }

  // Case 3 — Valid 6-digit pincode → fetch location details
  setState((prev) => ({
    ...prev,
    pincode: value,
    errorStatus: { ...prev.errorStatus, pincode: false },
    errorFields: { ...prev.errorFields, pincode: '' },
  }));

  if (value.length !== 6) return;

  try {
    setFetchGST(true);
    const res = await LocationFetch(value);

    // Fetch linked data
    await getStates('IndiaState');
    await getDistricts(res.State + 'District');
    GSTStatesModal('IndiaState', `${res?.State}District`);
    GSTDistrictsModal(`${res?.State}District`, `${res?.District}District`);

    // Match state from your array
    stateArr.forEach((ele) => {
      if (ele?.label?.toLowerCase() === res?.State?.toLowerCase()) {
        nameOfState = { label: ele.label, value: ele.value, code: ele.code };
      }
    });

    // Prepare city list
    const cityArr = (res?.City || []).map((ele) => ({
      label: ele,
      value: ele,
    }));
    setCityArr(cityArr);

    // Update dependent fields
    setState((prev) => ({
      ...prev,
      country: { label: 'India', value: 'IndiaState' },
      states: nameOfState,
      district: { label: res.District, value: res.District + 'District' },
      city: cityArr[0] || { label: '', value: '' },
      errorStatus: {
        ...prev.errorStatus,
        states: false,
        country: false,
        district: false,
      },
      errorFields: {
        ...prev.errorFields,
        states: '',
        country: '',
        district: '',
      },
    }));
  } catch (err) {
    console.error('Location fetch failed:', err);
    setState((prev) => ({
      ...prev,
      errorStatus: { ...prev.errorStatus, pincode: true },
      errorFields: {
        ...prev.errorFields,
        pincode: 'Unable to fetch location data',
      },
    }));
  } finally {
    setFetchGST(false);
  }
};
const handleCountryChange = (e, newValue) => {
  // Case 1 — Value cleared
  if (!newValue) {
    setIsChanged(true);
    setState((prev) => ({
      ...prev,
      country: { label: '', value: '' },
      states: { label: '', value: '', code: '' },
      district: { label: '', value: '' },
      city: { label: '', value: '' },
      errorStatus: { ...prev.errorStatus, country: true },
      errorFields: { ...prev.errorFields, country: 'Country is required' },
    }));
    return;
  }

  // Case 2 — Same value (no actual change)
  if (newValue?.value === state?.country?.value) {
    setIsChanged(false);
    return;
  }

  // Case 3 — Valid country change
  setIsChanged(true);
  getStates(newValue?.value); // Fetch state list for selected country

  setState((prev) => ({
    ...prev,
    country: newValue,
    // Reset dependent fields only if country actually changed
    states:
      newValue?.value !== prev?.country?.value
        ? { label: '', value: '', code: '' }
        : prev?.states,
    district:
      newValue?.value !== prev?.country?.value
        ? { label: '', value: '' }
        : prev?.district,
    city:
      newValue?.value !== prev?.country?.value
        ? { label: '', value: '' }
        : prev?.city,
    errorStatus: { ...prev.errorStatus, country: false },
    errorFields: { ...prev.errorFields, country: '' },
  }));
};
const handleStateChange = (e, newValue) => {
  // Case A — Autocomplete (for India)
  if (newValue !== undefined) {
    // Case 1 — Cleared selection
    if (!newValue) {
      setIsChanged(true);
      setState((prev) => ({
        ...prev,
        states: { label: '', value: '', code: 0 },
        district: { label: '', value: '' },
        city: { label: '', value: '' },
        errorStatus: { ...prev.errorStatus, states: true },
        errorFields: { ...prev.errorFields, states: 'State/Province is required' },
      }));
      return;
    }

    // Case 2 — Same selection, no change
    if (newValue?.value === state?.states?.value) {
      setIsChanged(false);
      return;
    }

    // Case 3 — New valid selection
    setIsChanged(true);
    getDistricts(newValue?.value);

    setState((prev) => ({
      ...prev,
      states: newValue,
      district:
        newValue?.value !== prev?.states?.value ? { label: '', value: '' } : prev?.district,
      city:
        newValue?.value !== prev?.states?.value ? { label: '', value: '' } : prev?.city,
      errorStatus: { ...prev.errorStatus, states: false },
      errorFields: { ...prev.errorFields, states: '' },
    }));
    return;
  }

  // Case B — Manual Input (for non-India countries)
  const value = e.target.value;

  setIsChanged(value !== state?.states?.label);

  let hasError = false;
  let errorMessage = '';

  if (value.trim() === '') {
    hasError = true;
    errorMessage = 'State/Province is required';
  }

  setState((prev) => ({
    ...prev,
    states: { label: value, value: 0, code: 0 },
    errorStatus: { ...prev.errorStatus, states: hasError },
    errorFields: { ...prev.errorFields, states: errorMessage },
  }));
};
const handleDistrictChange = (e, newValue) => {
  // Case A — Autocomplete (for India)
  if (newValue !== undefined) {
    // Case 1 — Cleared selection
    if (!newValue) {
      setIsChanged(true);
      setState((prev) => ({
        ...prev,
        district: { label: '', value: '' },
        city: { label: '', value: '' },
        errorStatus: { ...prev.errorStatus, district: true },
        errorFields: { ...prev.errorFields, district: 'District is required' },
      }));
      return;
    }

    // Case 2 — Same selection, no change
    if (newValue?.value === state?.district?.value) {
      setIsChanged(false);
      return;
    }

    // Case 3 — Valid new selection
    setIsChanged(true);
    setState((prev) => ({
      ...prev,
      district: newValue,
      city:
        newValue?.value !== prev?.district?.value
          ? { label: '', value: '' }
          : prev?.city,
      errorStatus: { ...prev.errorStatus, district: false },
      errorFields: { ...prev.errorFields, district: '' },
    }));
    return;
  }

  // Case B — Manual input (for non-India countries)
  const value = e.target.value;

  setIsChanged(value !== state?.district?.label);

  let hasError = false;
  let errorMessage = '';

  if (value.trim() === '') {
    hasError = true;
    errorMessage = 'District is required';
  }

  setState((prev) => ({
    ...prev,
    district: { label: value, value },
    errorStatus: { ...prev.errorStatus, district: hasError },
    errorFields: { ...prev.errorFields, district: errorMessage },
  }));
};
const handleCityChange = (e, newValue, reason) => {
  if (reason === "selectOption") {
    setIsChanged(newValue?.label !== state?.city?.label);

    setState((prev) => ({
      ...prev,
      city: {
        label: newValue?.label,
        value: newValue?.value,
      },
      errorStatus: { ...prev.errorStatus, city: false },
      errorFields: { ...prev.errorFields, city: "" },
    }));
    return;
  }

  if (reason === "input") {
    if (typeof newValue === "string") {
      setState((prev) => ({
        ...prev,
        city: { label: newValue, value: newValue },
      }));
    }
  }
};



  useSaveModalShortcut(saveChanges);
  return (
    <Box id={open ? 'DeliveryAddressModal' : ''}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 15px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {partyType === 'SUPPLIER' ? 'Edit Ship From Address' : 'Edit Ship To Address'}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                padding: '15px',
                height: { xs: '400px', sm: 'auto' },
                overflowY: { xs: 'scroll', sm: 'hidden' },
                minWidth: { xs: '400px' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'column' },
                  flexWrap: { xs: 'wrap', md: 'nowrap' },
                }}
              >
                {registrationType !== 1 ? (
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: 'flex' }}>
                    <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                      <TextField
                        name="gstin"
                        // placeholder="GSTIN"
                        label="GSTIN"
                        size="small"
                        value={state.gstin}
                        // required={state.gstin === '' ? true : false}
                        onChange={(e) => {
                          const name = e.target.name;
                          const value = e.target.value;
                          if (value === state?.gstin) {
                            setIsChanged(false);
                          } else {
                            setIsChanged(true);
                          }

                          if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Za-z]{1}$/.test(value) && value !== '') {
                            setState((prev) => ({
                              ...prev,
                              gstin: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                gstin: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                gstin: 'Invalid GSTIN',
                              },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              gstin: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                gstin: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                gstin: '',
                              },
                            }));
                            setData((prev) => ({
                              ...prev,
                              consigneeGST: value,
                            }));
                            setFetchGST(true);
                            getGSTDetails(value);
                          }
                        }}
                        sx={{
                          '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                            fontSize: '14px',
                          },
                          label: {
                            fontSize: '14px',
                          },
                          '.css-wgai2y-MuiFormLabel-asterisk': {
                            color: 'danger.main',
                          },
                        }}
                        InputLabelProps={{
                          shrink: true, // <- always float label (no overlap)
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                      <TextField
                        name="customerName"
                        label="Consignee Name"
                        size="small"
                        value={state.customerName}
                        InputLabelProps={{
                          shrink: true, // <- always float label (no overlap)
                        }}
                        // required={state.customerName === "" ? true : false}
                        sx={{
                          '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                            fontSize: '14px',
                          },
                          label: {
                            fontSize: '14px',
                          },
                          '.css-wgai2y-MuiFormLabel-asterisk': {
                            color: 'danger.main',
                          },
                        }}
                        onChange={(e) => {
                          const name = e.target.name;
                          const value = e.target.value;
                          // if (value === "") {
                          //   setState((prev) => ({
                          //     ...prev,
                          //     customerName: value,
                          //     errorStatus: {
                          //       ...prev.errorStatus,
                          //       customerName: true,
                          //     },
                          //     errorFields: {
                          //       ...prev.errorFields,
                          //       customerName: "Consignee Name is required",
                          //     },
                          //   }));
                          // } else {
                          if (value === state?.customerName) {
                            setIsChanged(false);
                          } else {
                            setIsChanged(true);
                          }
                          setState((prev) => ({
                            ...prev,
                            customerName: value,
                            errorStatus: {
                              ...prev.errorStatus,
                              customerName: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              customerName: '',
                            },
                          }));
                          setData((prev) => ({
                            ...prev,
                            consigneeName: value,
                          }));
                          // }
                        }}
                      />
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    <TextField
                      name="customerName"
                      placeholder="Customer Name"
                      label="Customer Name"
                      size="small"
                      fullWidth
                      value={state.customerName}
                      inputProps={{ readOnly: true }}
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                      }}
                    />
                  </Box>
                )}
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.deliveryAddress == true ? true : false}
                    name="deliveryAddress"
                    // label={partyType === 'SUPPLIER' ? 'Ship From Address' : 'Ship To Address'}
                    label="Address Details"
                    multiline
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="text"
                    required={eWayImp}
                    value={state.deliveryAddress}
                    // required={state.deliveryAddress === "" ? true : false}
                    rows={4}
                    sx={{
                      '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                        fontSize: '14px',
                      },
                      label: {
                        fontSize: '14px',
                      },
                      '.css-wgai2y-MuiFormLabel-asterisk': {
                        color: 'danger.main',
                      },
                    }}
                    InputProps={{
                      classes: {
                        input: 'custom-scrollbar', // Your custom class
                      },
                    }}
                    // onChange={(e) => {
                    //   const name = e.target.name;
                    //   const value = e.target.value;
                    //   // if (value === "") {
                    //   //   setState((prev) => ({
                    //   //     ...prev,
                    //   //     deliveryAddress: value,
                    //   //     errorStatus: {
                    //   //       ...prev.errorStatus,
                    //   //       deliveryAddress: true,
                    //   //     },
                    //   //     errorFields: {
                    //   //       ...prev.errorFields,
                    //   //       deliveryAddress: "Delivery Address is required",
                    //   //     },
                    //   //   }));
                    //   // } else {
                    //   if (value === state?.deliveryAddress) {
                    //     setIsChanged(false);
                    //   } else {
                    //     setIsChanged(true);
                    //   }
                    //   setState((prev) => ({
                    //     ...prev,
                    //     deliveryAddress: value,
                    //     errorStatus: {
                    //       ...prev.errorStatus,
                    //       deliveryAddress: false,
                    //     },
                    //     errorFields: {
                    //       ...prev.errorFields,
                    //       deliveryAddress: '',
                    //     },
                    //   }));
                    //   // }
                    // }}
                    onChange={handleDeliveryAddressChange}
                  />
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state.errorFields.deliveryAddress}
                  </Typography>
                </Box>
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: 'flex' }}>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    <TextField
                      error={state.errorStatus.pincode == true ? true : false}
                      name="pincode"
                      label="Postal / Zip Code"
                      variant="outlined"
                      size="small"
                      fullWidth

                      type="text"
                      required={eWayImp &&(state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                      value={state.pincode}
                      // required={true}
                      rows={4}
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                      }}
                      onChange={handlePincodeChange}
                    />
                    <Typography
                      sx={{
                        marginTop: '2px',
                        marginLeft: '10px',
                        marginBottom: '0px',
                        fontSize: '11px',
                        color: 'danger.main',
                      }}
                    >
                      {state.errorFields.pincode}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    <Autocomplete
                      name="country"
                      size="small"
                      fullWidth
                      isOptionEqualToValue={(option, value) => option.value === value?.value}
                      disableClearable={!state?.country?.value}
                      disablePortal

                      value={state.country}
                      options={countryArr}
                      onChange={handleCountryChange}
                      renderInput={(params) => (
                        <TextField
                          // required={state?.country?.value === "" ? true : false}
                          error={state?.errorStatus?.country}
                          required={eWayImp}
                          sx={{
                            '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                              padding: '8.5px 7px',
                            },
                            '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                              fontSize: '14px',
                            },
                            label: {
                              fontSize: '14px',
                            },
                            '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                              fontSize: '14px',
                            },
                            '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                              borderColor: 'input.border',
                            },
                            '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-14qz1ij-MuiListItemText-root': {
                              margin: '0px',
                            },
                            '.css-wgai2y-MuiFormLabel-asterisk': {
                              color: 'danger.main',
                              fontWeight: 'bold',
                              fontSize: '16px',
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          {...params}
                          label="Country"
                        />
                      )}
                    />
                    <Typography
                      sx={{
                        marginTop: '2px',
                        marginLeft: '10px',
                        marginBottom: '0px',
                        fontSize: '11px',
                        color: 'danger.main',
                      }}
                    >
                      {state?.errorFields?.country}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: 'flex' }}>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    {state?.country?.value === 'IndiaState' ? (
                      <Autocomplete
                        open={openState}
                        name="states"
                        size="small"
                        value={state.states}
                        disableClearable={!state.states?.value}

                        options={stateArr}
                       onChange={handleStateChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            onFocus={() => setOpenState(true)}
                            onBlur={() => setOpenState(false)}
                            error={state?.errorStatus?.states}
                            required={eWayImp &&(state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                            label="State/Province"
                            sx={{
                              '.MuiInputBase-input': { padding: '8.5px 7px' },
                              fontSize: '14px',
                              '.MuiFormLabel-asterisk': {
                                color: 'danger.main',
                                fontWeight: 'bold',
                                fontSize: '16px',
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        name="states"
                        label="State/Province"
                        value={state?.states?.label || ''}
                        onChange={handleStateChange}
                         error={state?.errorStatus?.states}
                            required={eWayImp &&(state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                        sx={{
                          '.MuiInputBase-input': { padding: '8.5px 7px' },
                          fontSize: '14px',
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontWeight: 'bold',
                            fontSize: '16px',
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                     <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state.errorFields.states}
                  </Typography>
                  </Box>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    {state?.country?.value === 'IndiaState' ? (
                      <Autocomplete
                        name="district"
                        size="small"
                        value={state.district}
                        disableClearable={!state?.district?.value}
                        options={districtArr}
                        onChange={handleDistrictChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={state?.errorStatus?.district}
                            required={eWayImp&&(state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                            label="District"
                            sx={{
                              '.MuiInputBase-input': { padding: '8.5px 7px' },
                              fontSize: '14px',
                              '.MuiFormLabel-asterisk': {
                                color: 'danger.main',
                                fontWeight: 'bold',
                                fontSize: '16px',
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        name="district"
                        label="District"
                        value={state?.district?.label || ''}
                         error={state?.errorStatus?.district}
                        required={eWayImp&&(state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                        onChange={handleDistrictChange
                        }
                        sx={{
                          '.MuiInputBase-input': { padding: '8.5px 7px' },
                          fontSize: '14px',
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontWeight: 'bold',
                            fontSize: '16px',
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                     <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state.errorFields.district}
                  </Typography>
                  </Box>
                </Box>
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: 'flex' }}>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    {/* {state?.country?.value === 'IndiaState' ? (
                      <Autocomplete
                        name="city"
                        placeholder="City"
                        size="small"
                        value={state.city}
                        disableClearable={!state?.city?.value}
                        options={cityArr}
                        onChange={(e, newValue) => {
                          if (!newValue) {
                            setState((prev) => ({
                              ...prev,
                              city: { label: '', value: '' },
                              errorStatus: { ...prev.errorStatus, city: false },
                              errorFields: { ...prev.errorFields, city: '' },
                            }));
                            return;
                          }

                          setIsChanged(newValue !== state?.city);
                          setState((prev) => ({
                            ...prev,
                            city: newValue,
                            errorStatus: { ...prev.errorStatus, city: false },
                            errorFields: { ...prev.errorFields, city: '' },
                          }));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={state?.errorStatus?.city}
                            label="City"
                            sx={{
                              '.MuiInputBase-input': { padding: '8.5px 7px' },
                              fontSize: '14px',
                              '.MuiFormLabel-asterisk': {
                                color: 'danger.main',
                                fontWeight: 'bold',
                                fontSize: '16px',
                              },
                            }}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                              autoCorrect: 'off',
                              spellCheck: 'false',
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        name="city"
                        label="City"
                        value={state?.city?.label || ''}
                        onChange={(e) =>
                          setState((prev) => ({
                            ...prev,
                            city: { label: e.target.value, value: e.target.value },
                            errorStatus: { ...prev.errorStatus, city: false },
                            errorFields: { ...prev.errorFields, city: '' },
                          }))
                        }
                        sx={{
                          '.MuiInputBase-input': { padding: '8.5px 7px' },
                          fontSize: '14px',
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontWeight: 'bold',
                            fontSize: '16px',
                          },
                        }}
                        inputProps={{
                          autoComplete: 'off',
                          autoCorrect: 'off',
                          spellCheck: 'false',
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )} */}
<Autocomplete
  name="city"
  size="small"
  freeSolo
  value={state.city || null}
  options={cityArr || []}

  getOptionLabel={(option) =>
    typeof option === "string" ? option : option?.label || ""
  }
  isOptionEqualToValue={(option, value) => option?.value === value?.value}

  onChange={handleCityChange}
  onInputChange={handleCityChange}

  renderInput={(params) => (
    <TextField
      {...params}
      label="City"
      InputLabelProps={{ shrink: true }}
      error={state?.errorStatus?.city}
      required={
        (eWayImp || eImp) &&
        (state?.country?.value === "IndiaState" ||
          state?.country?.value === "")
      }
      sx={{
        ".MuiInputBase-input": { padding: "8.5px 7px" },
        fontSize: "14px",
        ".MuiFormLabel-asterisk": {
          color: "danger.main",
          fontWeight: "bold",
          fontSize: "16px",
        },
      }}
      inputProps={{
        ...params.inputProps,
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: "false",
      }}
    />
  )}
/>

 <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state.errorFields.city}
                  </Typography>

                  </Box>
                </Box>
              </Box>
              {/* {isChanges === true && ( */}
              <FormControlLabel
                sx={{
                  margin: 1, // remove extra gap from label
                  '& .MuiFormControlLabel-label': {
                    color: 'primary.main',
                    // fontWeight: 'bold',
                    fontSize: '14px',
                  },
                  '& .MuiCheckbox-root': {
                    padding: 0, // shrink spacing
                    color: '#6096d9',
                    '&.Mui-checked': {
                      color: '#6096d9',
                    },
                  },
                }}
                control={
                  <Checkbox
                    size="small"
                    sx={{
                      '& .MuiSvgIcon-root': { fontSize: 16 }, // tick size
                    }}
                    checked={checkPermanent}
                    onChange={(e) => {
                      setCheckPermanent(e.target.checked);
                    }}
                  />
                }
                label={"Set this as default shipping address"
                  // partyType === 'CUSTOMER'
                  //   ? 'Save the ship to address permanently for the customer'
                  //   : 'Save the ship to address permanently for the supplier'
                }
              />
              {/* // )} */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: { sm: 'center' },
                  flexWrap: { xs: 'wrap', md: 'nowrap' },
                  flexDirection: { xs: 'column', sm: 'row' },
                  marginBottom: '0px',
                }}
              ></Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
              }}
            >
              <Button onClick={handleClear} variant="outlined" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
                Clear
              </Button>
              <Button onClick={handleClose} variant="outlined" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
                Cancel
              </Button>
              <Button onClick={saveChanges} variant="contained" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
                Save
              </Button>
            </Box>
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
};

export default EditDeliveryAddressModal;
